/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext, useContext } from 'react'
import { Block, RenderContextProvider, Renderer } from '@contensis/canvas-react'
import { StrongAl, EmphasisAl } from './decorators'
import {
  MyFragment,
  MyHeading,
  MyImage,
  MyList,
  MyListItem,
  MyParagraph,
  MyTable,
  MyEntry
} from './blocks'
import {
  ThirdsLayoutBlock,
  HalvesLayoutBlock,
  WholeLayoutBlock,
  ImageContent,
  AlertBlock,
  FeatureItemBlock,
  IntroTextBlock,
  StandardTextBlock,
  CTAs,
  AccordionBlock,
  Eyebrow,
  QuoteBlock,
  EntryBlock,
  CTADownload
} from './components'

import { cn } from '~/lib/utils'

const LayoutColourContext = createContext<any | undefined>(undefined)
export const useLayoutItems = () => useContext(LayoutColourContext)

const Canvas = ({
  content = { canvas: [], alignment: 'left' },
  containerId,
  className,
  layoutColour
}: {
  content: { canvas?: Block[]; alignment?: string }
  containerId?: string
  className?: string
  layoutColour?: string
}) => {
  const layoutItems = {
    layoutColour: layoutColour || 'white',
    alignment: content?.alignment || 'left'
  }

  return (
    <LayoutColourContext.Provider value={layoutItems}>
      <div
        {...(containerId !== '' ? { id: containerId } : {})}
        className={cn(
          !Array.isArray(content) && content?.alignment === 'centre'
            ? '[&_h3]:mb-2xs-plus [&_h4]:mb-xs [&_ul]:space-y-xs [&_ol]:space-y-xs [&>.tag]:mt-l flex flex-col items-center justify-center text-center [&_h2]:mb-[26px] [&_h5]:mb-[14px] [&_ul]:mx-auto [&_ul]:max-w-[80ch] [&_ul]:text-left [&>.tag+h2]:!mt-0 [&>.tag+h3]:!mt-0 [&>.tag+h4]:!mt-0 [&>.tag+h5]:!mt-0 [&>h5+ul]:mt-0'
            : '',
          ['light-pink', 'light-aqua', 'light-purple', 'light-orange'].includes(
            layoutColour ?? ''
          )
            ? '[&_a]:text-blue-d [&_a]:hover:text-white'
            : '',
          'space-y-l',
          className
        )}
      >
        <RenderContextProvider
          blocks={{
            _fragment: MyFragment,
            _heading: MyHeading,
            _image: MyImage,
            _list: MyList,
            _listItem: MyListItem,
            _paragraph: MyParagraph,
            _table: MyTable,
            _inlineEntry: MyEntry
          }}
          components={{
            layoutThirds: ThirdsLayoutBlock,
            layoutHalves: HalvesLayoutBlock,
            layoutWhole: WholeLayoutBlock,
            testImageContent: ImageContent,
            textIntroParagraph: IntroTextBlock,
            textBasic: StandardTextBlock,
            textStandard: StandardTextBlock,
            contentFeatureItem: FeatureItemBlock,
            uiAlert: AlertBlock,
            canvasCTABlock: CTAs,
            ctaDownload: CTADownload,
            canvasEyebrow: Eyebrow,
            canvasPullQuote: QuoteBlock,
            canvasAccordions: AccordionBlock,
            canvasEntrySelector: EntryBlock
          }}
          decorators={{
            strong: StrongAl,
            emphasis: EmphasisAl
          }}
        >
          <Renderer
            data={Array.isArray(content) ? content : content?.canvas || []}
          />
        </RenderContextProvider>
      </div>
    </LayoutColourContext.Provider>
  )
}

export default Canvas
